import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { shallowEqual, useSelector } from 'react-redux'

import { toast } from 'react-toastify'
import UseLogin from 'app/modules/core/hooks/users/UseLogin'
import { Helper, IUpdatePassword, UserProfileService } from 'app/modules/core'

const updatePassword: IUpdatePassword = {
    currentPassword: '',
    newPassword: '',
    passwordConfirmation: '',
}

const passwordFormValidationSchema = Yup.object().shape({
    newPassword: Yup.string()
        .min(6, 'Minimum 6 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Password is required'),
    passwordConfirmation: Yup.string()
        .min(6, 'Minimum 6 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Password is required')
        .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
})

type IChangePassProps = {
    userId: string
}
export const ChangePassword: React.FC<IChangePassProps> = (props) => {

    const [passwordUpdateData, setPasswordUpdateData] = useState<IUpdatePassword>(updatePassword)
    const [showPasswordForm, setPasswordForm] = useState<boolean>(false)
    const [loading2, setLoading2] = useState(false)

    //const userLogin = UseLogin()

    const formik2 = useFormik<IUpdatePassword>({
        initialValues: {
            ...passwordUpdateData,
        },
        validationSchema: passwordFormValidationSchema,
        onSubmit: (values) => {
            setLoading2(true)
            setTimeout(() => {
                if (props.userId)
                    UserProfileService.ChangePassword(props.userId, values)
                        .then(() => toast.success('Save Success.'))
                        .catch((ex) => toast.error(Helper.catchErrorMsg(ex)))
                toast.success('Save Success.')

                setPasswordUpdateData(values)
                setLoading2(false)
                setPasswordForm(false)
            }, 1000)
        },
    })

    return (
        <>
            <div className='d-flex flex-wrap align-items-center mb-10'>
                <div id='kt_signin_password' className={' ' + (showPasswordForm && 'd-none')}>
                    <div className='fs-6 fw-bolder mb-1'>Password</div>
                    <div className='fw-bold text-gray-600'>************</div>
                </div>

                <div
                    id='kt_signin_password_edit'
                    className={'flex-row-fluid ' + (!showPasswordForm && 'd-none')}
                >
                    <form
                        onSubmit={formik2.handleSubmit}
                        id='kt_signin_change_password'
                        className='form'
                        noValidate
                    >
                        <div className='row mb-1'>
                            {/* <div className='col-lg-4'>
                <div className='fv-row mb-0'>
                  <label htmlFor='currentpassword' className='form-label fs-6 fw-bolder mb-3'>
                    Current Password
                  </label>
                  <input
                    type='password'
                    className='form-control form-control-lg form-control-solid '
                    id='currentpassword'
                    {...formik2.getFieldProps('currentPassword')}
                  />
                  {formik2.touched.currentPassword && formik2.errors.currentPassword && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik2.errors.currentPassword}</div>
                    </div>
                  )}
                </div>
              </div> */}

                            <div className='col-lg-4'>
                                <div className='fv-row mb-0'>
                                    <label htmlFor='newpassword' className='form-label fs-6 fw-bolder mb-3'>
                                        New Password
                                    </label>
                                    <input
                                        type='password'
                                        className='form-control form-control-lg form-control-solid '
                                        id='newpassword'
                                        {...formik2.getFieldProps('newPassword')}
                                    />
                                    {formik2.touched.newPassword && formik2.errors.newPassword && (
                                        <div className='fv-plugins-message-container'>
                                            <div className='fv-help-block'>{formik2.errors.newPassword}</div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className='col-lg-4'>
                                <div className='fv-row mb-0'>
                                    <label htmlFor='confirmpassword' className='form-label fs-6 fw-bolder mb-3'>
                                        Confirm New Password
                                    </label>
                                    <input
                                        type='password'
                                        className='form-control form-control-lg form-control-solid '
                                        id='confirmpassword'
                                        {...formik2.getFieldProps('passwordConfirmation')}
                                    />
                                    {formik2.touched.passwordConfirmation && formik2.errors.passwordConfirmation && (
                                        <div className='fv-plugins-message-container'>
                                            <div className='fv-help-block'>{formik2.errors.passwordConfirmation}</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className='form-text mb-5'>
                            Password must be at least 8 character and contain symbols
                        </div>

                        <div className='d-flex'>
                            <button
                                id='kt_password_submit'
                                type='submit'
                                className='btn btn-primary me-2 px-6'
                            >
                                {!loading2 && 'Update Password'}
                                {loading2 && (
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        Please wait...{' '}
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    </span>
                                )}
                            </button>
                            <button
                                onClick={() => {
                                    setPasswordForm(false)
                                }}
                                id='kt_password_cancel'
                                type='button'
                                className='btn btn-color-gray-400 btn-active-light-primary px-6'
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>

                <div id='kt_signin_password_button' className={'ms-auto ' + (showPasswordForm && 'd-none')}>
                    <button
                        onClick={() => {
                            setPasswordForm(true)
                        }}
                        className='btn btn-light btn-active-light-primary'
                    >
                        Reset Password
                    </button>
                </div>
            </div>
        </>
    )
}
